import { useEffect, useState } from 'react';
import ProcedureList from '@src/cache/ProcedureList';
import useCachedSpecialitiesList from '@src/adapters/hooks/specialities/useCachedSpecialitiesList';

interface Props {
  procedureId: string;
}

function ProcedureSpecialityName({ procedureId }: Props) {
  const { getList: getProcedures } = ProcedureList();
  const { getList: getSpeciality } = useCachedSpecialitiesList();
  const [display, setDisplay] = useState('');
  useEffect(() => {
    getProcedures(procedureId).then((procedures) => {
      const procedure = procedures.find((p) => p.id === procedureId);
      if (procedure) {
        getSpeciality(procedure.specialityId).then((specialities) => {
          const speciality = specialities.find(
            (s) => s.id === procedure.specialityId
          );
          if (speciality) {
            setDisplay(speciality.name);
          } else {
            setDisplay('');
          }
        });
      } else {
        setDisplay('');
      }
    });
  }, [getProcedures, getSpeciality, procedureId]);
  return <span>{display}</span>;
}

export default ProcedureSpecialityName;
